var $dd0d25f885b5c5f3$exports = {};
$dd0d25f885b5c5f3$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Selector de color",
  "colorSwatch": "muestra de color",
  "transparent": "transparente",
  "twoDimensionalSlider": "Regulador 2D"
};
export { $dd0d25f885b5c5f3$exports as default };